"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberActionInput = void 0;
const react_1 = __importStar(require("react"));
require("./NumberActionInput.scss");
const NumberActionInput_scss_json_1 = __importDefault(require("./NumberActionInput.scss.json"));
const package_1 = require("../package");
const ActionTemplate_1 = require("../shapes/ActionTemplate");
const Topic_1 = require("../shapes/Topic");
const Button_1 = require("lincd-mui-base/lib/components/Button");
const GameAction_1 = require("../shapes/GameAction");
const CoreMap_1 = require("lincd/lib/collections/CoreMap");
const TopicScore_1 = require("../shapes/TopicScore");
const react_2 = require("@tolgee/react");
const Modal_1 = require("lincd-mui-base/lib/components/Modal");
const react_confetti_1 = __importDefault(require("react-confetti"));
const SubmitAsSubPlayer_1 = require("./SubmitAsSubPlayer");
const Player_1 = require("../shapes/Player");
const BonusActionInput_1 = require("./BonusActionInput");
const useAuth_1 = require("lincd-auth/lib/hooks/useAuth");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
const NodeSet_1 = require("lincd/lib/collections/NodeSet");
const helper_1 = require("../utils/helper");
const ImageUpload_1 = require("./molecules/ImageUpload");
exports.NumberActionInput = (0, package_1.linkedComponent)(Topic_1.Topic, ({ source, onScoreUpdated, teamChange, withImageUpload }) => {
    var _a;
    let topic = source;
    const actionTemplates = [...topic.actionTemplates];
    let auth = (0, useAuth_1.useAuth)();
    let user = auth.userAccount.accountOf;
    let isEventTeam = user === null || user === void 0 ? void 0 : user.isEventMode();
    const [medalScore, setMedalScore] = (0, react_1.useState)(null);
    const [scorePreview, setScorePreview] = (0, react_1.useState)();
    const [bonusQuantity, setBonusQuantity] = (0, react_1.useState)();
    const [formData, setFormData] = (0, react_1.useState)([]);
    const [finishedGameModal, setFinishedGameModal] = (0, react_1.useState)(false);
    const [submittedPointsMessage, setSubmittedPointsMessage] = (0, react_1.useState)('');
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [selectedSubPlayer, setSelectedSubPlayer] = (0, react_1.useState)(user);
    const [previousBonusActions, setPreviousBonusActions] = (0, react_1.useState)(null);
    const [selectedBonusAction, setSelectedBonusAction] = (0, react_1.useState)(null);
    const [submitCounter, setSubmitCounter] = (0, react_1.useState)(0);
    const [topicScore, setTopicScore] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        TopicScore_1.TopicScore.getOrCreateFor(topic, selectedSubPlayer || auth.user, user.currentTeam).then((response) => {
            if (onScoreUpdated) {
                onScoreUpdated(response);
            }
            if (response) {
                setMedalScore(response.score);
                setTopicScore(response);
            }
        });
    }, [selectedSubPlayer, teamChange]);
    (0, react_1.useEffect)(() => {
        GameAction_1.GameAction.getGameActionByTopic(topic).then((response) => {
            //collect all the custom bonus actions previousy submitted,
            //collect them by node to avoid dupplicates
            let bonusActionNodes = new NodeSet_1.NodeSet();
            //TODO: use response.custom...
            response === null || response === void 0 ? void 0 : response.gameActions.forEach((item) => {
                item.objects.forEach((object) => {
                    if (object.isCustom) {
                        bonusActionNodes.add(object.node);
                    }
                });
            });
            //convert the nodes to shapes and set the state
            setPreviousBonusActions(ActionTemplate_1.ActionTemplate.getSetOf(bonusActionNodes));
        });
    }, [selectedSubPlayer, teamChange, submitCounter]);
    const parseValue = (value) => {
        if (typeof value === 'number') {
            return value;
        }
        else if (typeof value === 'string') {
            const parsedValue = parseFloat(value);
            return isNaN(parsedValue) ? 0 : parsedValue;
        }
        else {
            return 0;
        }
    };
    const handleFormChange = (formId, templateUri, value, point) => {
        setFormData((prevData) => {
            const newData = [...prevData];
            newData[formId] = Object.assign(Object.assign({}, newData[formId]), { templateUri: templateUri, value: value, point: point });
            return newData;
        });
    };
    const renderForms = () => {
        return actionTemplates
            .filter((t) => !t.isBonus)
            .map((actionTemplate, index) => {
            var _a;
            return (react_1.default.createElement("div", { key: actionTemplate.uri, className: NumberActionInput_scss_json_1.default.ActionTemplate },
                react_1.default.createElement("input", { type: 'text', className: NumberActionInput_scss_json_1.default.TextField, key: actionTemplate.uri, value: ((_a = formData[index]) === null || _a === void 0 ? void 0 : _a.value) || '', onChange: (e) => {
                        if (/^\d*$/.test(e.target.value)) {
                            handleFormChange(index, actionTemplate.uri, e.target.value, actionTemplate.points);
                        }
                    }, "aria-label": actionTemplate.name, pattern: "\\d*", inputMode: "numeric" }),
                react_1.default.createElement("label", null, t(actionTemplate.identifier + '.name', actionTemplate.name))));
        });
    };
    const submitAction = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        let actionQuantityMap = new CoreMap_1.CoreMap();
        formData.forEach((data) => {
            let template = ActionTemplate_1.ActionTemplate.getFromURI(data.templateUri);
            actionQuantityMap.set(template, +data.value);
        });
        let _scorePreview = scorePreview;
        if (selectedBonusAction) {
            actionQuantityMap.set(selectedBonusAction, +bonusQuantity);
        }
        try {
            const result = yield (0, helper_1.withRetry)(() => GameAction_1.GameAction.submit(topic, actionQuantityMap, false, selectedSubPlayer));
            if (onScoreUpdated && result) {
                console.log(`Received updated topic score: ${result.topicScore.uri} - score: ${result.topicScore.score} - medal ${result.topicScore.medal}`);
                onScoreUpdated(result.topicScore);
                setMedalScore(result.topicScore.score);
                setSubmitCounter(submitCounter + 1);
                if (result.justFinishedGame) {
                    setFinishedGameModal(result.justFinishedGame);
                }
                else {
                    const youHave = t('numberActionInput.youHave', 'You have');
                    const removed = t('numberActionInput.removed', 'removed');
                    const earned = t('numberActionInput.earned', 'earned');
                    const actions = t('numberActionInput.points', 'actions');
                    const forText = t('numberActionInput.for', 'for');
                    setSubmittedPointsMessage(`${youHave} ${isNaN(_scorePreview) ? 0 : _scorePreview} ${actions} ${result.player.namedNode === user.namedNode
                        ? ''
                        : `${forText} ${result.player.givenName} ${result.player.familyName}`}`);
                    setTimeout(() => {
                        setSubmittedPointsMessage('');
                    }, 4000);
                }
            }
            setFormData([]);
            setScorePreview(undefined);
            setSelectedBonusAction(null);
            setBonusQuantity(undefined);
            setSelectedSubPlayer(null);
        }
        catch (error) {
            console.error('Error submitting action:', error);
            alert(t('numberActionInput.submitErrorMessage', 'With so many Peace Actions being submitted I got a little flustered. Bear with us and kindly resubmit your action(s) again in a few moments.'));
        }
        finally {
            setLoading(false);
        }
    });
    const subPlayerHandler = (event) => {
        const selectedPlayer = Player_1.Player.getFromURI(event.target.value);
        setSelectedSubPlayer(selectedPlayer);
    };
    let { t } = (0, react_2.useTranslate)();
    const onBonusTemplateSelected = (template) => {
        setSelectedBonusAction(template);
    };
    const updateScorePreview = () => __awaiter(void 0, void 0, void 0, function* () {
        let total = formData.reduce((acc, formData) => {
            if (formData &&
                typeof formData.value === 'string' &&
                typeof formData.point === 'number') {
                const formTotal = parseValue(formData.value) * formData.point;
                return acc + formTotal;
            }
            return acc;
        }, 0);
        if (selectedBonusAction && bonusQuantity) {
            //make sure bonusQuantity is no bigger than 10
            let updatedBonusQuantity = +bonusQuantity > 0 && +bonusQuantity > 10 ? 10 : +bonusQuantity;
            setBonusQuantity(updatedBonusQuantity);
            total += selectedBonusAction.points * +bonusQuantity;
        }
        setScorePreview(total);
    });
    (0, react_1.useEffect)(() => {
        updateScorePreview();
    }, [formData, bonusQuantity, selectedBonusAction]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ((_a = user.currentTeam) === null || _a === void 0 ? void 0 : _a.teamLeader) && (react_1.default.createElement(SubmitAsSubPlayer_1.SubmitAsSubPlayer, { onSubPlayerSelected: subPlayerHandler, selectedSubPlayer: selectedSubPlayer })),
        react_1.default.createElement("div", { className: NumberActionInput_scss_json_1.default.NumberActionInput },
            renderForms(),
            !isEventTeam && (react_1.default.createElement(BonusActionInput_1.BonusActionInput, { of: topic, selected: selectedBonusAction, quantity: bonusQuantity, onSelected: onBonusTemplateSelected, onQuantityChanged: (quantity) => setBonusQuantity(parseInt(quantity)), previousBonusActions: previousBonusActions, key: submitCounter, "aria-label": t('numberActionInput.bonusActionInput', 'Bonus Action Input') })),
            withImageUpload && topicScore && (react_1.default.createElement("div", { style: { paddingTop: '15px' } },
                react_1.default.createElement(ImageUpload_1.ImageUpload, { uploadUrl: `${process.env.SITE_ROOT}/call/${package_1.packageName}/uploadImage?topicScore=${topicScore.uri}&property=images&subPlayer=${(selectedSubPlayer === null || selectedSubPlayer === void 0 ? void 0 : selectedSubPlayer.uri) || (user === null || user === void 0 ? void 0 : user.uri)}`, of: topicScore, subPlayer: selectedSubPlayer, property: 'images', limit: 6, onCallback: (updatedTopicScore) => {
                        onScoreUpdated(updatedTopicScore);
                        setMedalScore(updatedTopicScore.score);
                        setSubmitCounter(submitCounter + 1);
                    } }))),
            react_1.default.createElement("b", null, t('word.peaceActions', 'Peace Actions')),
            react_1.default.createElement("div", { className: NumberActionInput_scss_json_1.default.ActionScore },
                react_1.default.createElement("input", { className: NumberActionInput_scss_json_1.default.TextField, value: scorePreview, readOnly: true, "aria-label": t('numberActionInput.scorePreview', 'Score Preview') }),
                medalScore != 0 && (react_1.default.createElement("p", null,
                    "+ ",
                    medalScore,
                    " = ",
                    medalScore ? medalScore + scorePreview : ''))),
            react_1.default.createElement("div", { className: NumberActionInput_scss_json_1.default.centered },
                react_1.default.createElement(Button_1.Button, { variant: "outlined", onClick: submitAction, disabled: loading }, loading ? (react_1.default.createElement("span", null, t('word.submitting', 'Submitting...'))) : (react_1.default.createElement("span", null, t('word.submit', 'Submit')))))),
        react_1.default.createElement(Modal_1.Modal, { isOpen: finishedGameModal, onClose: () => setFinishedGameModal(false), "aria-label": t('numberActionInput.finishedGameModal', 'Finished Game Modal') },
            react_1.default.createElement("div", { className: NumberActionInput_scss_json_1.default.modalForm },
                react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/Fire_Orange.gif') }),
                react_1.default.createElement("h3", null, t('word.congratulations', 'Congratulations!')),
                react_1.default.createElement("p", null, t('numberActionInput.successMessageGame', 'You have completed this game successfully!'))),
            react_1.default.createElement(react_confetti_1.default, null)),
        react_1.default.createElement(Modal_1.Modal, { isOpen: !!submittedPointsMessage, onClose: () => setSubmittedPointsMessage(''), "aria-label": t('numberActionInput.submittedPointsModal', 'Submitted Points Modal') },
            react_1.default.createElement("div", { className: NumberActionInput_scss_json_1.default.modalForm },
                react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/double-check.gif') }),
                react_1.default.createElement("h3", null, t('numberActionInput.successMessage', 'Score submitted successfully!')),
                react_1.default.createElement("p", null, submittedPointsMessage)))));
});
//register all components in this file
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=NumberActionInput.js.map